import React from "react";
import { Polyline } from "react-leaflet";

// отображения пунктирных линий uplink
const WifiUplinkLines = ({ item, data, dashOffset }) => {

  // ищем целевой узел, к которому подключён uplinkIp
  const target = data.find(
    (other) =>
      other !== item &&
      other.ip &&
      item.uplinkIp &&
      other.ip === item.uplinkIp
  );

  if (
    !target ||
    item.latitude === undefined ||
    item.longitude === undefined ||
    target.latitude === undefined ||
    target.longitude === undefined
  ) {
    return null; // ничего не рисуем
  }

  return (
    <Polyline
      key={`uplink-${item.index}`} // лучше использовать id, если есть
      positions={[
        [item.latitude, item.longitude],
        [target.latitude, target.longitude],
      ]}
      pathOptions={{
        color: "green",
        weight: 3,
        dashArray: "10, 10",
        dashOffset: dashOffset.toString(),
      }}
    />
  );
};

export default WifiUplinkLines;